import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { GlobalContext } from '../../Context/GlobalContext';
import useAxios from '../../Hooks/useAxios';
import MenuListTasks from '../MenuListTasks/MenuListTasks';
import ProcessForm from '../ProcessForm/ProcessForm';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { CircularProgress, Typography } from '@mui/material';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import { DATE_FORMAT, STATUS_RESOLVED } from '../../Constants/Global';
import { useAuth } from 'react-oidc-context';
import { useNavigate, useLocation } from 'react-router-dom';
import { AxiosService } from '../../Services/AxiosService';
import AltaCentroForm from '../AltaCentroForm/AltaCentroForm';
import { getSelectedProcess } from "../../Components/AltaCentroForm/AltaCentroForm";

/**
 * A reusable Paper component for the draggable dialog. This component is used to wrap the dialog content
 * and enable dragging functionality.
 * 
 * @component
 * @param {Object} props - The component props.
 * @param {React.RefObject} props.nodeRef - A ref to the Paper component.
 * @returns {JSX.Element} A draggable Paper component.
 */

 let getSelectedProcessId = getSelectedProcess();
 let endProcessDate = [];


function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper 
      {...props} 
      ref={nodeRef} 
      className="formPaper"
      sx={{
        overflow: "auto",
        position: "fixed",
        top: "90px",
        maxWidth: "420px",
        borderRadius: "30px"
      }}/>
    </Draggable>
  );
}

/**
 * A popup dialog component for managing process details. It includes a form for updating the process end date
 * and buttons for resolving, removing, or saving changes to the process. The dialog is draggable and integrates
 * with the global context for state management.
 * 
 * @component
 * @returns {JSX.Element} The rendered process popup dialog component.
 */
function ProcessDetails() {
  const {

    processModalOpen, 
    setProcessModalOpen, 
    setModalOpen, 
    modalData, 
    setAlertType, 
    setAlertMessage, 
    setAlertTitle,
    setAlertOpen, 
    setAlertBarSeverity,
    setAlertBarMessage,
    setAlertBarOpen,
    setRefreshTable
  } = React.useContext(GlobalContext);




  //console.log (data.id);
  //endProcessDate[0] = data.statusId;
  const [endDate, setEndDate]= React.useState();
  const [loadingRequest, setLoadingRequest] = React.useState(false);
  const navigate = useNavigate();
  const auth = useAuth();
  const { pathname } = useLocation();

  //function GetEndData(){
  console.log("getSelectedProcessId--", getSelectedProcessId);
  console.log("getSelectedProcessId[0]--", getSelectedProcessId[0]);
    const { data, isLoading, error } = useAxios("processDetail", getSelectedProcessId[0]);
    console.log("dataAA", data);
    console.log("dataData", data?.endDate);
    endProcessDate[0] = data?.endDate;
    if (data && Array.isArray(data)) {
        data.forEach((row)=> {
            console.log("row.date", row.endDate);
            endProcessDate[0] = row.endDate;
        });
    }



}
export const getEndProcessDate = () => {
  console.log("endProcessDate-------", endProcessDate);
  return endProcessDate;
};

export default ProcessDetails;
